import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'penalties_monetary_otherwise_are_used_ensure_that_workers'

export const dataPointDefinition = {
  retracedId: 'penalties_monetary_otherwise_are_used_ensure_that_workers',
  name: 'Penalties (monetary or otherwise) are used to ensure that workers use PPE equipment and clothing',
  description: 'Penalties can include, but are not limited to, suspension, fines, change in pay or position.',
  meta: {
    slcpMeta: {
      key: 'hs-31--1-8x',
      number: 'HS-WOR-8-6',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-wor-18',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2]',
      machineShowHide: '[2]',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-31--1-8x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29280,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
